import React from 'react';
export function Brand(_a) {
    var src = _a.src, link = _a.link, alt = _a.alt;
    var brand = src ? React.createElement("img", { src: src, alt: alt }) : alt;
    return React.createElement(React.Fragment, null, link ? React.createElement("a", { href: link }, brand) : brand);
}
//# sourceMappingURL=Brand.js.map